import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Metric = 'units' | 'billing' | 'daily';

type DashboardFilters = {
  companyIds?: string[];
  marketIds?: string[];
  brands?: string[];
  models?: string[];
  isThreeWheeler?: boolean;
  startDate?: Date | string;
  endDate?: Date | string;
  sellerIds?: string[];
  startDay?: number;
  endDay?: number;
  years?: number[];
  isManufactureYear?: boolean;
  isUnit?: boolean;
  metric?: Metric;
  yearsStock?: number[];
};

const initialState: DashboardFilters = {
  companyIds: [],
  marketIds: [],
  brands: [],
  models: [],
  isThreeWheeler: false,
  startDate: undefined,
  endDate: undefined,
  sellerIds: [],
  startDay: undefined,
  endDay: undefined,
  years: [],
  isManufactureYear: true,
  isUnit: true,
  metric: 'units',
  yearsStock: [],
};

const dashboardFiltersSlice = createSlice({
  name: 'dashboardFilters',
  initialState,
  reducers: {
    setDashboardFilters: (state, action: PayloadAction<DashboardFilters>) => {
      return { ...state, ...action.payload };
    },
    resetDashboardFilters: () => initialState,
  },
});

export const { setDashboardFilters, resetDashboardFilters } = dashboardFiltersSlice.actions;

const DashboardFilterReducer = dashboardFiltersSlice.reducer;
export default DashboardFilterReducer;
